import { Outlet } from "react-router-dom";

const SecureComp = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default SecureComp;
